import { hooks } from '@approvalmax/utils';
import { hooks as pageHooks } from 'modules/page';
import { useCallback, useState } from 'react';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';
import { useEnableProfileTwoFaSetting } from 'shared/hooks';

export const useTwoFaHardEnforcement = () => {
    const enableProfileTwoFaSetting = useEnableProfileTwoFaSetting();

    const [stage, setStage] = useState<'start' | 'wizard' | 'end'>('start');
    const [redirectUrl] = hooks.useQueryParam('redirectUrl');

    const authenticated = pageHooks.useProtectedAuth();

    const handleWizardStart = useCallback(() => {
        setStage('wizard');
    }, [setStage]);

    const handleWizardEnd = useCallback(() => {
        enableProfileTwoFaSetting();
        setStage('end');
    }, [enableProfileTwoFaSetting, setStage]);

    const handleDone = useCallback(() => {
        storageService.resetIsTwoFaHardEnforcement();

        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            routingService.reloadToDefaultPath();
        }
    }, [redirectUrl]);

    return {
        stage,
        authenticated,
        handleWizardStart,
        handleWizardEnd,
        handleDone,
    };
};
